import { render, staticRenderFns } from "./MonthlyUserExtend.vue?vue&type=template&id=970948aa"
import script from "./MonthlyUserExtend.vue?vue&type=script&lang=js"
export * from "./MonthlyUserExtend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports